import React from 'react';
import { startOfWeek } from '../../utils/date-utils';

const WALNUT = '#8B4513';
const STONE = '#8C8275';

function getWeekNumber(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return weekNo;
}

export default function WeekNumberColumn({ weeks }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      width: '50px',
      marginRight: '12px'
    }}>
      {/* Header */}
      <div style={{
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: '600',
        color: STONE,
        borderBottom: `1px solid ${STONE}33`
      }}>
        WK
      </div>

      {/* Week Numbers */}
      {weeks.map((weekStart, index) => (
        <div
          key={index}
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: '600',
            color: WALNUT,
            background: `${WALNUT}0A`,
            borderRadius: '8px',
            margin: '4px 0'
          }}
        >
          {getWeekNumber(weekStart)}
        </div>
      ))}
    </div>
  );
}